import React from "react";
import { FormattedMessage } from "react-intl";

export default {
    drivers: {
        name: "driverId",
        label: <FormattedMessage id="trip-form.driver" />,
        type: "list",
        // helpText: 'Driver',
        url: "/drivers",
        filterValue: "name",
        errorMessage: <FormattedMessage id="trip-form.err-msg-driver" />,
        validation: {
            required: true,
        },
        confirmable: true,
        fieldConfirmation: {
            title: <FormattedMessage id="trip-form.confirm-driver-confirmation-title" />,
            content: <FormattedMessage id="trip-form.confirm-driver-confirmation-content" />,
        },
    },
    trucks: {
        name: "truckId",
        label: <FormattedMessage id="trip-form.truck" />,
        type: "list",
        // helpText: 'Trucks',
        url: "/trucks",
        filterValue: "keyword",
        itemLabels: ["plateNumber", "model"],
        errorMessage: <FormattedMessage id="trip-form.err-msg-truck" />,
        validation: {
            required: true,
        },
        confirmable: true,
        fieldConfirmation: {
            title: <FormattedMessage id="trip-form.confirm-truck-confirmation-title" />,
            content: <FormattedMessage id="trip-form.confirm-truck-confirmation-content" />,
        },
    },
    branches: {
        name: "branchId",
        label: <FormattedMessage id="trip-form.branch" />,
        type: "list",
        // helpText: 'Branches',
        url: "/branches",
        filterValue: "organizationId",
        itemLabels: ["nameAr"],
        errorMessage: <FormattedMessage id="branch-form.err-msg-name" />,
        validation: {
            required: true,
        },
    },
    tripTypes: {
        name: "tripTypeId",
        label: <FormattedMessage id="trip-form.type" />,
        type: "list",
        // helpText: 'Trip types',
        url: "/trip-types",
        filterValue: "name",
        errorMessage: <FormattedMessage id="trip-form.err-msg-type" />,
        formatLabels: true,
        validation: {
            required: true,
        },
    },
    category: {
        name: "dropoffCategory",
        label: <FormattedMessage id="trip-form.location-category" />,
        type: "list",
        url: "/location-categories",
        filterValue: "nameAr",
        errorMessage: <FormattedMessage id="trip-form.err-msg-location-category" />,
        validation: {
            required: false,
        },
    },
    governorate: {
        name: "dropoffGovernorate",
        label: <FormattedMessage id="trip-form.governorate" />,
        type: "list",
        url: "/governorates",
        filterValue: "nameAr",
        errorMessage: <FormattedMessage id="trip-form.err-msg-governorate" />,
        validation: {
            required: false,
        },
    },
    area: {
        name: "dropoffArea",
        label: <FormattedMessage id="trip-form.area" />,
        type: "list",
        url: "/areas",
        filterValue: "name",
        errorMessage: <FormattedMessage id="trip-form.err-msg-area" />,
        validation: {
            required: false,
        },
    },
    city: {
        name: "dropoffCity",
        label: <FormattedMessage id="trip-form.city" />,
        type: "list",
        url: "/cities",
        filterValue: "nameAr",
        errorMessage: <FormattedMessage id="trip-form.err-msg-city" />,
        validation: {
            required: false,
        },
    },
    location: {
        name: "dropoffLocation",
        label: <FormattedMessage id="trip-form.location-name" />,
        type: "list",
        // helpText: 'Address',
        url: "/locations",
        filterValue: "name",
        errorMessage: <FormattedMessage id="trip-form.err-msg-location-name" />,
        itemLabels: ["nameAr", "name", "areaName"],
        validation: {
            required: false,
        },
    },
    supplier: {
        name: "supplierId",
        label: <FormattedMessage id="trip-form.supplier-name" />,
        type: "list",
        // helpText: 'Supplier name',
        url: "/suppliers",
        filterValue: "name",
        errorMessage: <FormattedMessage id="trip-form.err-msg-supplier-name" />,
        validation: {
            required: true,
        },
        confirmable: true,
        fieldConfirmation: {
            title: <FormattedMessage id="trip-form.confirm-supplier-confirmation-title" />,
            content: <FormattedMessage id="trip-form.confirm-supplier-confirmation-content" />,
        },
    },
    supplierContractType: {
        name: "supplierContractType",
        label: <FormattedMessage id="trip-form.supplier-contract-type" />,
        type: "list",
        data: [
            { value: 0, label: "Monthly" },
            { value: 1, label: "On Demand" },
        ],
        filterValue: "name",
        errorMessage: <FormattedMessage id="trip-form.err-msg-supplier-contract-type" />,
        validation: {
            required: true,
        },
        fieldConfirmation: {
            title: <FormattedMessage id="trip-form.confirm-supplier-confirmation-title" />,
            content: <FormattedMessage id="trip-form.confirm-supplier-confirmation-content" />,
        },
    },
};
